import React, { Component } from "react"
import Modal from 'react-modal'
import { Grid, Row, Col, Well } from 'react-bootstrap'
import settings from '../../../settings'
import axios from 'axios'
import ReactJson from 'react-json-view'

import '../../Modals/Modal.css'

const customStyles = {
    content: {
        position: 'fixed',
        top: '15%',
        left: '12%',
        right: 'auto',
        bottom: 'auto',
        padding: 20,
        zIndex: 9999,
        border: 'none',
        width: '70%',
        height: '80%',
        backgroundColor: 'white',
        border: '1px solid lightgrey'
    }
}

class SesamViewLogModal extends Component {
    constructor(props) {
        super(props)
        this.state = { data: null }
    }

    componentWillMount() {
        const rq = this.props.requestContext
        var url = `${window.MYQLOCX_API}/subject/admin/bi/sesam/log?awsRequestId=${rq.awsRequestId}&logGroupName=${rq.logGroupName}&logStreamName=${rq.logStreamName}`

        console.log(url)

        axios.get(url).then(t => {
            this.setState({ data: t.data })
        }).catch(e => {
            console.log(e)
        })
    }

    render() {
        return (
            <Modal
                ariaHideApp={false}
                isOpen={true}
                onRequestClose={() => this.props.closeModal()}
                style={customStyles}>

                {this.state.data === null ? 'Laddar ...' :

                    <Grid fluid>
                        <Row>
                            <Col xs={12} sm={12} md={12} lg={12} style={{ textAlign: 'right' }}>
                                <span onClick={() => this.props.closeModal()} className="closeButton2">X</span>
                            </Col>
                        </Row>

                        {/* <Row>
                            <Col xs={12} sm={3} md={3} lg={3} style={{ textAlign: 'center' }}>
                                verbose
                            </Col>

                            <Col xs={12} sm={3} md={3} lg={3} style={{ textAlign: 'center' }}>
                                info
                            </Col>

                            <Col xs={12} sm={3} md={3} lg={3} style={{ textAlign: 'center' }}>
                                warning
                            </Col>

                            <Col xs={12} sm={3} md={3} lg={3} style={{ textAlign: 'center' }}>
                                error
                            </Col>
                        </Row>

                        <hr /> */}

                        <Row>
                            <Col xs={12} md={12} lg={12} style={{ fontSize: 12 }}>
                                {this.state.data.map(event => {
                                    let msg, json

                                    var message = event.message.split(this.props.requestContext.awsRequestId)[1]

                                    let jsonI = message.indexOf("JSON=")

                                    msg = message.slice(0, jsonI)

                                    try {
                                        json = JSON.parse(message.slice(jsonI + 5))
                                    } catch (e) {
                                        // console.log(e, event.message)
                                        // console.log(message.slice(jsonI + 5))
                                        // msg = `Problem med att parsa meddelande, ${JSON.stringify(event.message)}`
                                        msg = message
                                    }

                                    return (
                                        <Well key={event.eventId}>
                                            {msg}
                                            <ReactJson collapsed={false} displayDataTypes={false} name={false} displayObjectSize={false} src={json || {}} />
                                        </Well>
                                    )
                                })}
                            </Col>
                        </Row>

                    </Grid >
                }
            </Modal>
        )

    }
}

// const mapState = state => {
//     return {
//         sesamLogView: state.dataAnalytics.sesamLogView
//     }
// }

// const mapDispatch = (dispatch) => {
//     return {
//         getSesamLog: (...args) => dispatch(getSesamLog(...args))
//     }
// }

export default SesamViewLogModal